module.exports = __webpack_public_path__ + "img/logo.c1752cbd.svg";